import React, { useState, useContext, useCallback, useMemo } from 'react';

import { Language, FeedType } from '../../App';
const TYPES_DATA = [
    { text: 'todo', type: 'all' },
    { text: 'posts', type: 'posts' },
    { text: 'polls', type: 'poll' },
    { text: 'webinars', type: 'webinar' },
    { text: 'clinical_studiess', type: 'clinical-image' },
  ];
const usePostSideFilters = () => {
    const { lang } = useContext(Language);
    const { updateFeedType } = useContext(FeedType);
    const [type, setType] = useState(() => sessionStorage.getItem('FeedType') || 'all');
  
    const handleType = useCallback(
      (selectedType) => {
        // Clear session storage
        sessionStorage.removeItem('prevFeedData');
        sessionStorage.removeItem('prevFeedDataDetails');
        sessionStorage.removeItem('page');
        sessionStorage.setItem('FeedType', selectedType);
  
        // Update state and context
        setType(selectedType);
        updateFeedType(selectedType);
  
        // Scroll to top
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      [updateFeedType]
    );
  
    // Memoize TYPES_DATA to prevent re-creation
    const typesData = useMemo(() => TYPES_DATA, []);
  
    return {
      lang,
      type,
      typesData,
      handleType,
    };
  };

  export default usePostSideFilters